import api from "./api";

const getBanks = async () => {

    const response = await api.get("/api/banks");

    return response.data.data;

};

const addBank = async(formData)=>{
	console.log('Testing');
	console.log(formData);
    const response = await api.post(
        "/api/bank",
        formData
    );

    return response.data;

}

const updateBank = async(id,formData)=>{

    const response = await api.put(
        `/api/banks/${id}`,
        formData,
        {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        }
    );

    return response.data;

}

const deleteBank = async(id)=>{

    const response = await api.delete(`/api/banks/${id}`);

    return response.data;

}

export default{
    getBanks,
    addBank,
    updateBank,
    deleteBank
}